import React, { useEffect, useState, useRef } from 'react';
import Player from './../player/Player';
import Performances from './../player/Performances';
import NewTracks from './../views/NewTracks';
import Grid from '@mui/material/Grid';
import navigationStore from './../../stores/navigation';
import { Views } from './../../enums/enums';
import Catalog from './Catalog';
import Search from './Search';
import SongbookPerformances from './SongbookPerformances';
import Favorites from './Favorites';
import Singers from './Singers';
import Home from './Home';
import BackgroundMusic from './BackgroundMusic';
import PlayLists from './PlayLists';
import Settings from './Settings';
import Account from './Account';
import Feedback from './Feedback';
import ChangePassword from './ChangePassword';
import ChangeUsername from './ChangeUsername';

function SongbookContainer() {

  const currentView = navigationStore((state) => state.currentView);

  const renderView = (view) => {
    switch (view) {
      case Views.Search:
        return <Search isSongbook={true} />;
      case Views.Catalog:
        return <Catalog isSongbook={true} />;
      case Views.SongbookPerformances:
        return <SongbookPerformances isSongbook={true} />;
      default:
        return <NewTracks isSongbook={true} />;
    };
  };

  return (
    <Grid container spacing={0}>
      <Grid item xs={12} className="muvika-songbook-container-grid">
        <div className="muvika-songbook-container-view" >
          {renderView(currentView)}
        </div>
      </Grid>
    </Grid>
  );
}

export default SongbookContainer;